<template>
  <div>
    <b-row v-show="!isNewWorkOrder" class="text-right" align="right">
      <b-col>
        <b-form-group
          label="Status"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <div
            class="status-detail"
            :class="itemRowBackground(this.detail.status)"
            size="sm"
            disabled
          >
            {{ this.detail.status }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Contractor Name"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.contractor_name"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group
          label="Validity Period"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-input-group>
            <b-form-input
              v-model="detail.validity_periode_start"
              type="text"
              placeholder="-"
              autocomplete="off"
              disabled
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="detail.validity_periode_start"
                button-only
                left
                locale="en-US"
                size="sm"
                aria-controls="example-input"
                :disabled="!isNewWorkOrder"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="" label-size="sm" label-class="font-weight-bold">
          <br />
          <b-input-group>
            <b-form-input
              v-model="detail.validity_periode_end"
              type="text"
              placeholder="-"
              autocomplete="off"
              disabled
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="detail.validity_periode_end"
                button-only
                left
                locale="en-US"
                size="sm"
                aria-controls="example-input"
                :disabled="!isNewWorkOrder"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Contract Number"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.contractor_number"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Division"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.division.name"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Order Number"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.order_number"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Department"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.department_name"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Budget Code"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.budget_code"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Job Desc"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.job_desc"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      types: Object,
      default: () => ({
        contractor_name: '',
        validity_periode_start: '',
        validity_periode_end: '',
        contractor_number: '',
        department: '',
        order_number: '',
        job_desc: '',
        budget_code: '',
        division: ''
      })
    },
    isNewWorkOrder: {
      types: Boolean,
      default: () => false
    }
  },
  methods: {
    itemRowBackground(status) {
      if (status === 'Draft') {
        return 'draft'
      } else if (status === 'Approved') {
        return 'approved'
      } else if (status === 'Revise') {
        return 'revised'
      } else if (status === 'Waiting Approval') {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    }
  }
}
</script>
